import React, {FC} from "react";
import {RightCircleFilled} from "@ant-design/icons";
import {JCard} from "../JCard";
import { JHTML } from "../JHTML";
import './JCardViewAll.scss';

interface JCardViewAllProps {
    onClick?: () => void
    title: string;
}

export const JCardViewAll: FC<JCardViewAllProps> = (props) => {
    return(
        <JCard
            onClick={props?.onClick}
            type={"vertical"}
            contentComponent={
                <div className={'viewAll'}>
                    {props.title && <JHTML.Title html={props.title}/>}
                    <RightCircleFilled className={'arrow'} />
                </div>
            }/>
    )
}